import { Eye, EyeOff, X } from 'lucide-react';
import React, { useState, useEffect, memo } from 'react';
import styled from 'styled-components/macro';
import Modal from "react-modal";
import { ArrowLeft } from 'lucide-react';

 import './style.css';

// Your existing imports - replace these with your actual paths
import WhiteLogo from 'assets/images/logoWhite.svg'
import appDownloadQR from 'assets/images/loginPageImages/appDownloadQR.webp';
import img_19834580_6165258 from 'assets/images/img_19834580_6165258.svg';
import SecondUsp from '../../LoginPage/images/SecondUsp.svg';
import ThirdUsp from '../../LoginPage/images/ThirdUsp.svg';

// Your existing imports from old component
import { useSelector } from 'react-redux';
import { RootState } from 'controller/types';
import { Link, useSearchParams } from 'react-router-dom';
import { getCurrentYear, validatePassword } from 'core/utils/constants';
import { SetupLoader } from 'core/components/SetupComponents/SetupLoader';
import { ComponentProps } from 'features/Authentication';
import Carousel from './Carousel';
import { showGlobalModal } from 'core/components/GlobalModal';
import EncryptedStorage from 'core/utils/constants/encryptedStorage';
import { useDispatch } from 'react-redux';
import { authenticationActions as actions } from '../../slice';

Modal.setAppElement("#root"); // important for accessibility

export const HandSpan = styled.span`
  animation: wave 2.1s 0.6s infinite;
  transform-origin: 75% 75%;
  display: inline-block;
  margin-left: 4px;
  font-size: 2rem;

  @keyframes wave {
    0% {
      transform: rotate(0deg);
    }
    10% {
      transform: rotate(16deg);
    }
    20% {
      transform: rotate(-6deg);
    }
    30% {
      transform: rotate(16deg);
    }
    40% {
      transform: rotate(-4deg);
    }
    50% {
      transform: rotate(16deg);
    }
    60% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;

export const USPs = [
  {
    image: img_19834580_6165258,
    text: "A One stop Solution for Schools All Over India"
  }, {
    image: SecondUsp,
    text: "India's First School ERP Powered By AIS"
  }, {
    image: ThirdUsp,
    text: "Effortless Virtual Support and Communication"
  }
];

export const DesktopComponent = memo((props: ComponentProps) => {
  // State management from old component
  const [display, setDisplay] = useState<boolean | undefined>(false);
  const [displayText, setDisplayText] = useState<boolean | undefined>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [id, setId] = useState<number>(0);
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [forceLoggingIn, setForceLoggingIn] = useState<number | 'all' | null>(null);
  const [cachedSessionError, setCachedSessionError] = useState<any>(null);
  // Form data state
  const [data, setData] = useState<{ username: string; password: string; isHaveReaded: boolean }>({
    username: '',
    password: '',
    isHaveReaded: false
  });

  // Touch tracking for validation
  const [isTouched, setIsTouched] = useState({
    username: false,
    password: false,
  });

  const [searchParams] = useSearchParams();
  const state: any = useSelector((state: RootState) => state.authentication);
  const dispatch = useDispatch();

  // Add handler for remember me checkbox
  const handleRememberMeChange = (checked: boolean) => {
    setRememberMe(() => checked);

    if (checked) {
      // Save to EncryptedStorage when checked
      EncryptedStorage.setRememberMe(true);
    } else {
      // Remove from EncryptedStorage when unchecked
      EncryptedStorage.removeItem('rememberMe');
    }
  };

  // USP rotation effect from old component
  useEffect(() => {
    const timer = setTimeout(() => {
      setId(prevId => (prevId + 1) % 3);
    }, 6000);
    return () => clearTimeout(timer);
  }, [id]);

  // Notification class animation
  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setClass('show fade-out');
  //   }, 3000);
  //   return () => clearInterval(timer);
  // }, []);

  // Error handling from old component
  useEffect(() => {
    if (state?.errorLoggingIn) {
      setDisplay(true);
      setData(data => ({ ...data, username: props.username, password: props.password }));
      const timeout = setTimeout(() => {
        setDisplayText(true);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [state?.errorLoggingIn, props.username, props.password]);

  useEffect(() => {
    if (state?.sessionLimitError) {
      setCachedSessionError(state.sessionLimitError);
      setForceLoggingIn(null);
    }
  }, [state?.sessionLimitError]);

  useEffect(() => {
    if (!state?.isLoggingIn && !state?.sessionLimitError && !forceLoggingIn) {
      setCachedSessionError(null);
    }
  }, [state?.sessionLimitError, state?.isLoggingIn, forceLoggingIn]);

  // Form validation helpers
  const handleTouch = (field) => {
    setIsTouched(prevState => ({
      ...prevState,
      [field]: true,
    }));
  };

  const handleIsReaded = (value) => {
    setData(data => ({ ...data, isHaveReaded: value }));
  };

  const compareValues = () => {
    return props.username === data.username && props.password === data.password;
  };

  const disable = (!props.username.length || !props.password.length || !!validatePassword(props.password) || !data?.isHaveReaded);
  const passwordError = isTouched.password && !!validatePassword(props.password);

  useEffect(() => {
    if (searchParams.get('__resetPassword')) {
      showGlobalModal("You have successfully reset your password.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.get('__resetPassword')]);

  return (
    <>
      {/* Reset password notification */}
      {/* {searchParams.get('__resetPassword') && (
        <Notification className={`z-[999] ${__class}`} type="success">
          <p className="text-[1.7vh] w-max text-center pl-[1%]">
            You have successfully reset your password.
          </p>
        </Notification>
      )} */}
      <div className="relative font-poppins min-h-screen bg-[url('/src/assets/images/imageBG.webp')] bg-cover bg-center grid place-items-center p-4">
        {/* Logo */}
        <div className="absolute top-6 left-40">
          <img src={WhiteLogo} alt='WhiteLogo' className='w-[30vh]' />
        </div>

        {/* <div className="grid grid-cols-2 w-full items-center justify-items-center"> */}
        <div className="flex items-center justify-center gap-[16vh]">
          {/* Left side - Marketing content with USP rotation */}
          <div className="flex justify-end max-w-xl">
            <div className="flex flex-col justify-center items-center text-[white] gap-8">
              <Carousel />
            </div>
          </div>

          {/* Right side - Login form */}
          <div className="relative w-full justify-self-center max-w-md">
            {/* Error message */}
            {state?.errorLoggingIn && display && compareValues() && (
              <div className="absolute -top-16 bg-red-500/20 border border-red-500/30 rounded-xl p-3 mb-4 flex items-center gap-4 w-full">
                <X
                  className="w-6 h-6 text-[white]/90 cursor-pointer"
                  onClick={() => setDisplay(false)}
                />
                <span className={`text-[white]/90 text-[1.7vh] ${!displayText && 'hidden'}`}>
                  {state.errorLoggingIn}
                </span>
              </div>
            )}

            <div className="bg-[white]/10 backdrop-blur-md rounded-3xl p-8 shadow-2xl border border-[white]/20">
              {(cachedSessionError) ? (
                <>
                  <div className="flex items-start justify-between gap-2 mb-4">
                    <div>
                      <h2 className="text-[2.8vh] font-bold text-[white] mb-1">Session Limit Reached</h2>
                      <p className="text-[white]/80 text-[1.5vh]">
                        {cachedSessionError?.message || 'You have reached the maximum number of active sessions.'}
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col gap-3 max-h-[36vh] overflow-y-auto pr-1">
                    {cachedSessionError?.data?.ACTIVE_SESSIONS?.map((session, index) => (
                      <div key={index} className="bg-[white]/10 border border-[white]/20 rounded-2xl p-4 flex flex-row justify-between items-center gap-3">
                        <div className="flex flex-col flex-1 gap-0.5 min-w-0">
                          <div className="flex items-center gap-2">
                            <span className="font-semibold text-[white] text-[1.6vh]">{session.DEVICE_TYPE}</span>
                            <span className="text-[1.3vh] bg-[white]/20 text-[white]/90 px-2 py-0.5 rounded-full">{session.ROLE}</span>
                          </div>
                          <div className="text-[1.4vh] text-[white]/60">
                            Location: {session.LOCATION || 'Unknown'}
                          </div>
                          <div className="text-[1.4vh] text-[white]/60 truncate" title={session.DEVICE_INFO}>Browser: {session.DEVICE_INFO}</div>
                          <div className="text-[1.4vh] text-[white]/60">Last Active: {new Date(session.ACTIVITY_DATETIME).toLocaleString()}</div>
                        </div>
                        <button
                          onClick={(e) => {
                            if (props?.handleLogin) {
                              setForceLoggingIn(session.USER_LOGIN_ID);
                              props.handleLogin(e as any, session.USER_LOGIN_ID);
                            }
                          }}
                          disabled={!!forceLoggingIn && state?.isLoggingIn}
                          className="flex-shrink-0 flex items-center justify-center gap-2 px-3 py-2 bg-red-500/80 hover:bg-red-500 disabled:opacity-60 disabled:cursor-not-allowed text-white rounded-xl transition-colors font-medium text-[1.4vh] border border-red-400/30 min-w-[110px]"
                        >
                          {forceLoggingIn === session.USER_LOGIN_ID && state?.isLoggingIn ? (
                            <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                            </svg>
                          ) : 'Logout & Login'}
                        </button>
                      </div>
                    ))}
                  </div>

                  <div className='mt-4 bg-[white]/10 h-[1px] w-full' />
                  <div className="flex items-center justify-between mt-4">
                    <button
                      onClick={() => {
                        setCachedSessionError(null);
                        dispatch(actions.clearSessionLimitError());
                      }}
                      disabled={!!forceLoggingIn && state?.isLoggingIn}
                      className="flex items-center gap-1.5 px-4 py-2 bg-[white]/10 hover:bg-[white]/20 disabled:opacity-40 disabled:cursor-not-allowed text-[white]/80 hover:text-[white] rounded-xl transition-colors text-[1.5vh] font-medium border border-[white]/20"
                    >
                      <ArrowLeft className="w-4 h-4" /> Cancel
                    </button>
                    <button
                      onClick={(e) => {
                        const sessions = cachedSessionError?.data?.ACTIVE_SESSIONS;
                        if (sessions?.length && props?.handleLogin) {
                          setForceLoggingIn('all');
                          props.handleLogin(e as any, sessions.map(s => s.USER_LOGIN_ID));
                        }
                      }}
                      disabled={!!forceLoggingIn && state?.isLoggingIn}
                      className="flex-shrink-0 flex items-center justify-center gap-2 px-4 py-2 bg-red-500/80 hover:bg-red-500 disabled:opacity-60 disabled:cursor-not-allowed text-white rounded-xl transition-colors font-medium text-[1.5vh] border border-red-400/30 min-w-[140px]"
                    >
                      {forceLoggingIn === 'all' && state?.isLoggingIn ? (
                        <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                        </svg>
                      ) : 'Logout All & Login'}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="mb-8">
                    <h2 className="text-[4vh] font-bold text-[white] mb-2">
                      Welcome <HandSpan>👋🏼</HandSpan>
                    </h2>
                    <p className="text-[white]/90">Let's Explore SOOMUCH</p>
                  </div>

                  <div className="space-y-6">
                    <div>
                      <input
                        type="text"
                        placeholder="Phone Number"
                        value={props.username}
                        onChange={(e) => props.setUsername(e.target.value)}
                        onBlur={() => handleTouch('username')}
                        className="w-full bg-[white]/20 backdrop-blur-sm border border-[white]/30 rounded-2xl px-4 py-3 text-[white] text-[1.7vh] placeholder-[white]/90 focus:outline-none focus:border-[white]/50 focus:bg-[white]/25 transition-all"
                        required
                      />
                    </div>

                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={props.password}
                        onChange={(e) => props.setPassword(e.target.value)}
                        onBlur={() => handleTouch('password')}
                        className={`w-full bg-[white]/20 backdrop-blur-sm border ${passwordError ? 'border-red-400' : 'border-[white]/30'} rounded-2xl px-4 py-3 pr-12 text-[white] text-[1.7vh] placeholder-[white]/90 focus:outline-none focus:border-[white]/50 focus:bg-[white]/25 transition-all`}
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-[white]/60 hover:text-[white]/90 transition-colors"
                      >
                        {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                      </button>
                      {passwordError && (
                        <p className="text-red-300 text-[1.7vh] mt-1">{validatePassword(props.password)}</p>
                      )}
                    </div>

                    <div className="flex items-center justify-between text-[1.7vh]">
                      <div className="flex items-center space-x-2 text-[white]/90">
                        <input
                          type="checkbox"
                          checked={rememberMe}
                          onChange={(e) => handleRememberMeChange(e.target.checked)}
                          className="w-4 h-4 rounded border-[white]/30 bg-[white]/20 text-purple-500 focus:ring-purple-500 focus:ring-2"
                        />
                        <span>Remember me</span>
                      </div>
                      <Link to="/forgot-password" className="text-[white]/80 hover:text-[white] transition-colors">
                        forgot password?
                      </Link>
                    </div>

                    <div className="flex items-start space-x-2 text-[1.7vh] text-[white]/90">
                      <input
                        type="checkbox"
                        checked={data.isHaveReaded}
                        onChange={(e) => handleIsReaded(e.target.checked)}
                        className="w-4 h-4 mt-0.5 rounded border-[white]/30 bg-[white]/20 text-purple-500 focus:ring-purple-500 focus:ring-2"
                      />
                      <span>
                        I have read accepted the{' '}
                        <button
                          type="button"
                          onClick={() => window.open("https://soomuch.ai/privacy-policy", "_blank")}
                          className="font-semibold underline"
                        >
                          Terms & Conditions
                        </button>
                      </span>
                    </div>

                    {state?.isLoggingIn ? (
                      <div className="flex justify-center">
                        <div className="bg-neutral-light p-2 rounded-full">
                          <SetupLoader height="h-[7vh]" />
                        </div>
                      </div>
                    ) : (
                      <button
                        onClick={(e) => !!props?.handleLogin ? props?.handleLogin(e as any) : ""}
                        disabled={disable}
                        className={`w-full py-3 rounded-2xl font-semibold transition-all transform hover:scale-105 active:scale-95 ${disable
                          ? 'bg-[white]/40 text-[white] cursor-not-allowed opacity-40'
                          : 'bg-[white]/90 text-purple-600 hover:bg-[white]'
                          }`}
                      >
                        Log In
                      </button>
                    )}

                    <p className="text-center text-[white]/90 text-[1.7vh]">
                      Login as parent?{" "}
                      <ImageModal
                        imageSrc={appDownloadQR}
                        altText="Mobile app screenshot"
                      >
                        <span className="text-[white] underline hover:cursor-pointer">
                          Download mobile app to login
                        </span>
                      </ImageModal>
                    </p>
                  </div>

                  <div className='mt-4 bg-[white]/10 backdrop-blur-md h-[2px] w-full' />
                  <div className="text-center mt-4 text-[white]/90 text-[1.9vh]">
                    © {getCurrentYear()}, SooMuch.AI All Rights Reserved.
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

    </>
  );
});

// Custom tooltip component
export const ImageModal = ({ children, imageSrc, altText }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <span
        onClick={() => setIsOpen(true)}
        className="cursor-pointer"
      >
        {children}
      </span>

      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        className="flex justify-center items-center h-full outline-none"
        overlayClassName="fixed inset-0 bg-black/70 flex justify-center items-center"
      >
        <div className="bg-[white] rounded-lg p-4 relative max-w-sm w-full shadow-lg">
          <button
            onClick={() => setIsOpen(false)}
            className="absolute -top-10 -right-10 text-gray-600 hover:text-gray-900 bg-neutral-light py-2 px-3 rounded-full"
          >
            ✕
          </button>
          <img
            src={imageSrc}
            alt={altText}
            className="w-full h-auto rounded"
          />
        </div>
      </Modal>
    </>
  );
};
